export function getView(value) {
  return value?.id
}
